import { api } from './'
import { CARRELLOLATER } from './endpoint'

export const FetchCarrelloLater = async (setLoading, setCarrelloLater, router) => {
  setLoading(true)
  api
    .get(CARRELLOLATER, { params: { lang: router.locale } })
    .then((response) => {
      setCarrelloLater(response.data)
      setLoading(false)
    })
    .catch((err) => setLoading(false))
}
